export class Turbine {
    /* eslint-disable */
    _id: string;
    id_device: number;
    id_windpark: string;
    name: string;
    parkName: string;
    ratedPower: number;
    lat: number;
    lon: number;
    serial: string;
    serialDisplay: string;
    code: string;
    type: string;
    codeDisplay: string;
    /* eslint-enable */

    constructor(
      _id: string,
      idDevice?: number,
      idWindpark?: string,
      code?: string,
      parkName?: string,
      ratedPower?: number,
      lat?: number,
      lon?: number,
      serial?: string,
      codeDisplay?: string,
      type?: string,
      serialDisplay?: string
    ) {
      this._id = _id;
      this.id_device = idDevice;
      this.id_windpark = idWindpark;
      this.name = codeDisplay;
      this.codeDisplay = codeDisplay;
      this.code = code;
      this.parkName = parkName;
      this.ratedPower = ratedPower;
      this.lat = lat;
      this.lon = lon;
      this.serial = serial;
      this.serialDisplay = serialDisplay;
      this.type = type;
    }
}
